import axios from "axios";

const TOKEN_KEY = "edil_token";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const authApi = {
  login: (password) => axios.post(`${BACKEND_URL}/api/auth/login`, { password }).then((r) => r.data),
  me: () => axios.get(`${BACKEND_URL}/api/auth/me`, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  googleStatus: () => axios.get(`${BACKEND_URL}/api/auth/google/status`, { withCredentials: true }).then((r) => r.data),
  googleLoginConfig: () => axios.get(`${BACKEND_URL}/api/auth/google/login-config`, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  saveGoogleLoginConfig: (data) => axios.post(`${BACKEND_URL}/api/auth/google/login-config`, data, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  googleLoginUrl: () => `${BACKEND_URL}/api/auth/google/login`,
  googleAccount: () => axios.get(`${BACKEND_URL}/api/auth/google/account`, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  googleDisconnect: () => axios.delete(`${BACKEND_URL}/api/auth/google/account`, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  logout: () => axios.post(`${BACKEND_URL}/api/auth/logout`, null, { headers: getToken() ? { Authorization: `Bearer ${getToken()}` } : {}, withCredentials: true }).then((r) => r.data),
  changePassword: (current_password, new_password) =>
    axios.post(`${BACKEND_URL}/api/auth/change-password`, { current_password, new_password }, { headers: { Authorization: `Bearer ${getToken()}` } }).then((r) => r.data),
};

export const formatApiErrorDetail = (detail, fallback = "Si è verificato un errore. Riprova.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const attachAuth = (client, onUnauthorized) => {
  client.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  client.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401) {
        setToken(null);
        onUnauthorized?.();
      }
      if (err?.response?.status === 403) window.dispatchEvent(new Event("edil:permissions-changed"));
      return Promise.reject(err);
    }
  );
};
